import React, { useState } from "react";
import { blurBg, iButton } from "../assets/img";
import { useAppContext } from "../Services/AppContext";
import useStore from "./redux/store/useStore";

const Holiday = () => {
  const [info, setInfo] = useState(false);
  const { holiday } = useStore();

  const ReasonData = localStorage.getItem("reason");

  const Reason = holiday?.reason || ReasonData;

  return (
    <div
      className="holiday-container"
      style={{ backgroundImage: `url(${blurBg})` }}
    >
      <div className="holiday-blur">
        <h2 className="holiday-text">
          HOLIDAY{" "}
          <button
            className="info-btn"
            onClick={() => setInfo(true)}
            aria-label="Info"
          >
            <img src={iButton} alt="info" className="info-icon" />
          </button>
        </h2>

        {info && (
          <div className="modalOverlay2" onClick={() => setInfo(false)}>
            <div className="clasInfo2" onClick={(e) => e.stopPropagation()}>
              <p className="f3">{Reason || "No holiday reason provided."}</p>
              <button className="okBtn" onClick={() => setInfo(false)}>
                Okay
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Holiday;
